import { ArticlesApi } from '@src/api/articles.ts';
import { CoachesApi } from '@src/api/coaches.ts';
import { CommonApi } from '@src/api/common.ts';
import { ExercisesApi } from '@src/api/exercises.ts';
import { ProgramsApi } from '@src/api/programs.ts';
import { UsersApi } from '@src/api/users.ts';
import { instanceCore } from './instances.ts';

const programs = new ProgramsApi(instanceCore);
const articles = new ArticlesApi(instanceCore);
const users = new UsersApi(instanceCore);
const common = new CommonApi(instanceCore);
const exercises = new ExercisesApi(instanceCore);
const coaches = new CoachesApi(instanceCore);

export const API = {
  coaches,
  articles,
  programs,
  users,
  common,
  exercises,
};
